/* eslint-disable class-methods-use-this */
import { Component, ComponentControllerBase, ControllerRootOptions, Publish } from '@rta/rta-blueprint-library';

import { DesignerOptions } from './designer-options.class';
import { DesignerOptionsData } from './types/designer-options-data.type';
import { IRender3dApplianceController } from './types/render3d-appliance-controller.interface';
import { Viewport } from './Viewport.class';
// import { zoomCfn } from './functions';

export class Appliance3dController extends ComponentControllerBase implements IRender3dApplianceController {
	#forceRenderCount: number;
	#zoom: number;
	#zoomPromise: Promise<void>;
	#isRendering: boolean;
	#isZooming: boolean;
	#rebuild: () => void;
	#viewport: Viewport;
	#component: Component | null;

	#designerOptions: DesignerOptions;

	readonly options: DesignerOptionsData;

	/*
		subscribe:String->String->(Dynamic->Void)->Void,
		options:DesignerOptionsDataComplete
	*/
	constructor (component?: Component, options?: ControllerRootOptions<null>) {
		super('appliance-3d-controller', null, { eventGroup: 'appliance-3d-component', ...options });

		this.#forceRenderCount = 0;
		this.#zoom = 100;
		this.#zoomPromise = null;
		this.#isRendering = false;
		this.#isZooming = false;
		this.#rebuild = () => { this.#forceRenderCount++; };
		this.#viewport = new Viewport({ zoom: 1 });

		this.#component = component;

		// Initialize options with default values
		this.#designerOptions = new DesignerOptions({ dataIn: {}, parent: this }, this as unknown as any);
		this.options = this.#designerOptions as unknown as DesignerOptionsData;

		this.setInitialized();
	}

	get isZooming (): boolean { return this.#isZooming; }
	get viewport (): Viewport { return this.#viewport; }
	get isRendering (): boolean { return this.#isRendering; }
	get forceRenderCount (): number { return this.#forceRenderCount; }

	@Publish('appliance_3d_component', 'updated')
	set component (component: Component | null) {
		this.#component = component;
		this.#rebuild();
	}
	get component (): Component { return this.#component; }

	@Publish('appliance_3d_zoom', 'updated')
	set zoom (zoom: number) {
		this.#zoom = zoom;
	}
	get zoom (): number { return this.#zoom; }

	@Publish('appliance_3d_image', 'snapshot')
	getImage (): string | null {
		return null;
	}

	@Publish('rednering', 'updated')
	public setRendering (isRendering: boolean): void {
		this.#isRendering = isRendering;
	}
	public getRendering (): boolean { return this.#isRendering; }


	public rebuild (): void {
		// console.log('Appliance:rebuild');
		this.#rebuild();
	}

	public setRebuild (fn: () => void): void {
		this.#rebuild = fn;
	}

	public render (): void {
		this.#forceRenderCount++;
	}
}
